import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11zm0-1c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-4.806-8.776a.49.49 0 0 1-.08-.703.53.53 0 0 1 .726-.078l3.065 2.37 5.191-5.645a.53.53 0 0 1 .73-.042c.214.184.233.5.043.706l-5.517 6a.53.53 0 0 1-.71.058l-3.448-2.666z"
});

var SvgCheckmarkCircle = function SvgCheckmarkCircle(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgCheckmarkCircle;